/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UploadedFileFromJSON, UploadedFileToJSON } from './UploadedFile';
export function EuSiteSectionDocumentDocumentFromJSON(json) {
    return EuSiteSectionDocumentDocumentFromJSONTyped(json, false);
}
export function EuSiteSectionDocumentDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        title: !exists(json, 'title') ? undefined : json['title'],
        publishedAt: !exists(json, 'published_at') ? undefined : json['published_at'],
        archivedAt: !exists(json, 'archived_at') ? undefined : json['archived_at'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
        thumbnail: !exists(json, 'thumbnail') ? undefined : UploadedFileFromJSON(json['thumbnail']),
        largeThumbnail: !exists(json, 'large_thumbnail') ? undefined : UploadedFileFromJSON(json['large_thumbnail']),
        publicLinkUlid: !exists(json, 'public_link_ulid') ? undefined : json['public_link_ulid']
    };
}
export function EuSiteSectionDocumentDocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        published_at: value.publishedAt,
        archived_at: value.archivedAt,
        created_at: value.createdAt,
        updated_at: value.updatedAt,
        thumbnail: UploadedFileToJSON(value.thumbnail),
        large_thumbnail: UploadedFileToJSON(value.largeThumbnail),
        public_link_ulid: value.publicLinkUlid
    };
}
